import {TimeValue} from "../../types/datetime";

export function roundTo15MinutesDown(hours: number, minutes: number): TimeValue {
    // Calculate the total minutes
    const totalMinutes = hours * 60 + minutes;

    // Calculate the remainder when dividing by 15
    const remainder = totalMinutes % 15;

    // Subtract the remainder to round down to the closest 15-minute interval
    const roundedTotalMinutes = totalMinutes - remainder;

    // Convert back to hours and minutes
    const roundedHours = Math.floor(roundedTotalMinutes / 60);
    const roundedMinutes = roundedTotalMinutes % 60;

    return {
        hours: roundedHours,
        minutes : roundedMinutes
    };
}
